import React, { useContext } from 'react';
import { useNavigate } from 'react-router';
import { DASHBOARD, VERIFY_RECOVERY_CODE } from '@/constants/routes';
import { RESET_PASSWORD_MUTATION } from '@/api/mutations';
import { ForgotPasswordData } from './ForgotPasswordForm';
import { useMutation } from '@apollo/client';

const useForgotPasswordRequest = () => {
    const navigate = useNavigate();
    const [ resetPassword ] = useMutation(RESET_PASSWORD_MUTATION)


    const handleForgotPassword = async (values: ForgotPasswordData, setError: (error: string) => void) => {

        try {
            const req = await resetPassword({ variables: values });

            if (req.data?.resetPassword?.message) {
                if (req.data.resetPassword.__typename == "ErrorType") return setError(req.data?.resetPassword?.message);
    
                return navigate(VERIFY_RECOVERY_CODE, { state: values });
                
            }
            if (req.errors) {
                setError(req.errors.toString());
            }
    
        } catch (e){
            setError(String(e))
        }
    }

    return {
        forgotPassword: handleForgotPassword
    }
}

export default useForgotPasswordRequest;